import clsx from "clsx";
import { PropsWithChildren } from "react";

export const minWidth = "min-w-[1032px]";

export function ContentWidth({
  children,
  width = "medium",
  className,
}: PropsWithChildren<{ width?: "small" | "medium" | "large" | "infinity"; className?: string }>) {
  // NOTE: Use pixel values in these styles because we use this Component also to limit viewport sizes and
  // macOS' and Windows' default screen zoom should not interfere with that!

  const contentWidths = {
    small: "max-w-[640px]",
    medium: "max-w-[1384px]",
    large: "max-w-[1536px]",
    infinity: "max-w-auto",
  };

  const maxWidth = contentWidths[width];

  return <div className={clsx("mx-auto px-6", maxWidth, minWidth, className)}>{children}</div>;
}
